import { useState, useEffect } from "react";
import { Drawer, Button, Tag, ConfigProvider } from "antd";
import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import AlternativeProductCard from "./AlternativeProductCard";
import config from "../../../configuration/config";
import axios from "axios";
import {useIsMobile} from "../../../hooks/useIsMobile";
import i18n from "i18next";
// const products = [
//   {
//     id: 1,
//     name: "فحمات أمامية",
//     code: "0446560340W",
//     price: 666.66,
//     oldPrice: 784.3,
//     outOfStock: true,
//   },
//   {
//     id: 2,
//     name: "فحمات أمامية",
//     code: "0446560250",
//     price: 666.66,
//     oldPrice: 784.3,
//     outOfStock: true,
//   },
// ];
export const theme = {
  colors: {
    primary: "#E30613",
    textPrimary: "#000000",
    textSecondary: "#6B7280",
    danger: "#DC2626",
    success: "#16A34A",
    border: "#E5E7EB",
    bgMuted: "#F9FAFB",
  },

  fontSize: {
    xs: "12px",
    sm: "13px",
    base: "14px",
    md: "16px",
    lg: "18px",
    xl: "20px",
    title: "22px",
  },

  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
};

export default function AlternativeProductsDrawer({ open, onClose, productId }) {
  const [lang, setlang] = useState(localStorage.getItem("i18nextLng"));
  const isMobile = useIsMobile();
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const showLoading = () => {
    setLoading(true);
    // Simple loading mock. You should add cleanup logic in real world.
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };
  useEffect(() => {
    console.info("RequsetProductsWithDetails:", productId);
    console.info("RequsetProductsWithDetails:", open);
    console.info("RequsetProductsWithDetails:", products);
    if (open && productId && products.length <= 0) {
      console.info("RequsetProductsWithDetails>>>>>>>>>>>:", products);
      RequsetProductsWithDetails(productId);
    }
  }, [productId, products, open]);
  function RequsetProductsWithDetails(productId) {
    setLoading(true);
    const Body = {
      productID: productId,
    };
    axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/Site_FeatchAlternativeTransPart`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        // console.log(response.data.ApiObjectData);
        setProducts(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }

  return (
    <ConfigProvider direction={lang === "ar" ? "rtl" : "ltr"}>
      <Drawer
        title={
          <span
            style={{
              fontSize: theme.fontSize.title,
              fontWeight: theme.fontWeight.bold,
            }}>
            العناصر البديلة
          </span>
        }
        open={open}
        onClose={onClose}
        placement={isMobile ? "bottom" : undefined}
        height={isMobile ? "100%" : undefined}
        width={isMobile ? "100%" : 420}
        bodyStyle={{
          padding: isMobile ? "16px" : "24px",
          paddingBottom: "110px", // مهم حتى لا يختفي المحتوى خلف الفوتر
        }}
        footerStyle={{
          padding: "16px",
          borderTop: "1px solid #f0f0f0",
          background: "#fff",
        }}
        footer={
          <div className="space-y-3">
            <Button
              type="primary"
              block
              size="middle"
              className="bg-primary"
              // onClick={handleCheckout}
            >
              الإنتقال إلى الدفع
            </Button>

            <Button block size="middle" onClick={onClose}>
              متابعة التسوق
            </Button>
          </div>
        }
        loading={loading}
        closeIcon={<CloseOutlined style={{ width: "2.5rem", height: "2.5rem" }} />}>
        <div className="space-y-6">
          {products.map((item) => (
            <AlternativeProductCard key={item.id} item={item} />
          ))}
        </div>
      </Drawer>
    </ConfigProvider>
  );
}
